import { render, staticRenderFns } from "./AlgoliaResultCounter.vue?vue&type=template&id=038322a6&"
import script from "./AlgoliaResultCounter.vue?vue&type=script&lang=js&"
export * from "./AlgoliaResultCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports